//Cart
$(document).on("cart.requestComplete", function (event, cart) {
  var cartCount = cart.item_count;
  // var cartAmount = cart.total_price;
  // var success = $(".feedback .success");

  $(".cart-count").html(cartCount);
  // $("#cart-amount").html(cartAmount / 100);
  // success.addClass("appear");
  //console.log(cartCount);

  if(cartCount == 0){
    $("#side-cart").addClass("empty");
    $("#cart-page").addClass("empty");
    $("#cart-btn").addClass("hide");
    $("#bag-btn").addClass("hide");
  } else {
    $("#side-cart").removeClass("empty");
    $("#cart-page").removeClass("empty");
    $("#cart-btn").removeClass("hide");
    $("#bag-btn").removeClass("hide");
  }
  if($("#cart-page").hasClass('cart-page-over')){

  } else {
    $("#side-cart").addClass("open");
  }
  //loginMargin();
});

$(document).on("cart.ready", function (event, cart) {
  if (cart.item_count == 0) {
    $("#cart-btn").addClass("hide");
    $("#bag-btn").addClass("hide");
    $("#side-cart").addClass("empty");
    $("#cart-page").addClass("empty");
  } else {
    $("#cart-btn").removeClass("hide");
    $("#bag-btn").removeClass("hide");
    $(".cart-count").html(cart.item_count);
  }
  //loginMargin();
  //console.log(cart.item_count + " items in cart");
});

//Contact Page
let contactSide = document.querySelector("#side-contact");
let contactBtn = document.querySelectorAll("#contact-btn");
let closeContact = document.querySelector("#close-contact");

contactBtn.forEach(function(item, i){
  item.addEventListener("click", function (event) {
    event.preventDefault();
    contactSide.classList.add("open");
  });
})

closeContact.addEventListener("click", function (event) {
  event.preventDefault();
  contactSide.classList.remove("open");
});

//Cart
let sideCart = document.querySelector('#side-cart');
let cartBtn = document.querySelector('#cart-btn a');
let closeCart = document.querySelector('#close-cart');

cartBtn.addEventListener("click", function (event) {
  event.preventDefault();
  sideCart.classList.add("open");
});

closeCart.addEventListener('click', function(event){
  event.preventDefault();
  sideCart.classList.remove('open')
});

//Mobile Nav Button
let menuBtn = document.querySelector('#menu-btn');
let mobileMenu = document.querySelector('#mobile-nav');
let tempHeader = document.querySelector('header');

menuBtn.addEventListener('click', function(event){
  event.preventDefault();
  menuBtn.classList.toggle('is-active')
  mobileMenu.classList.toggle('open');
  tempHeader.classList.toggle('temp-white');
});

//Newsletter
let newsletterFormWrap = document.querySelectorAll('.newsletter-form-wrap');

if (newsletterFormWrap.length > 0) {

  newsletterFormWrap.forEach(function (item) {
    let newsletterForm = item.querySelector('form');
    let newsletterEmail = item.querySelector('#newsletter-email');
    let successMessage = item.querySelector('.success');
    let errorMessage = item.querySelector('.error');

    newsletterForm.addEventListener('submit', function (event) {
      event.preventDefault();

      const emailValue = newsletterEmail.value;

      const payload = {
        data: {
          type: "subscription",
          attributes: {
            profile: {
              data: {
                type: "profile",
                attributes: {
                  email: emailValue,
                  properties: {
                    "website-source": "email-capture"
                  }    
                },
              },
            },
          },
          relationships: {
            list: {
              data: {
                type: "list",
                id: "X7YtJj",
              },
            },
          },
        },
      };

      const requestOptions = {
        method: 'POST',
        headers: {
          'content-type': 'application/vnd.api+json',
          revision: '2024-10-15',
        },
        body: JSON.stringify(payload),
      };

      fetch('https://a.klaviyo.com/client/subscriptions?company_id=UBGrwp', requestOptions)
        .then((res) => {
          if (res.ok) {
            // Check if there is content to parse
            return res.text().then((text) => (text ? JSON.parse(text) : {}));
          } else {
            return res.json().then((errorDetails) => {
              throw new Error(`Failed to subscribe: ${errorDetails.message}`);
            });
          }
        })
        .then((res) => {
          console.log('Submission successful:', res);
          newsletterForm.classList.add('hide'); // Hide form
          successMessage.classList.remove('hide'); // Show success message
          errorMessage.classList.add('hide'); // Hide error message if visible
        })
        .catch((err) => {
          console.error('Error occurred:', err);
          successMessage.classList.add('hide'); // Hide success message if visible
          errorMessage.classList.remove('hide'); // Show error message
        });
    });
  });
}